import { useCallback } from 'react';
import { useSnackbar } from 'notistack';

export const useCopyToClipboard = () => {
  const { enqueueSnackbar } = useSnackbar();

  const copyToClipboard = useCallback(
    (content: string) => {
      navigator.clipboard.writeText(content).then(
        () => {
          enqueueSnackbar('Le contenu a bien été copié.');
        },
        () => {
          enqueueSnackbar("Le contenu n'a pas pu être copié.", {
            variant: 'error',
          });
        },
      );
    },
    [enqueueSnackbar],
  );

  return { copyToClipboard };
};
